import { Component, Input } from '@angular/core';
import { AlertButtonStyle, AlertStyle, AlertType } from './single-alert';

@Component({
  selector: 'app-single-alert',
  templateUrl: './single-alert.component.html',
})
export class SingleAlertComponent {
  @Input() isModal: boolean;
  @Input() alertType: AlertType;
  @Input() alertStyle: AlertStyle = 'block';
  @Input() alertButtonStyle: AlertButtonStyle = 'full';
  @Input() hasButtons = true;
  @Input() reverseButtonOrder = false;
  @Input() heading: string;
  @Input() ariaText: string;
  @Input() alignLeft = false;
  @Input() topMargin = true;
}
